// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-panel {
  display: flex;
  overflow: hidden;
  max-width: 100%;
  flex: 1 1;
}

.information-space {
  flex: 0 0 300px;
  gap: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  overflow: auto;
}

.information-space > * {
  width: 205px;
}

.information-space .task-text {
  border: solid 1px #1a6a7c;
  border-radius: 10px;
  background: #ffffff;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
  overflow: hidden;
  min-height: 120px;
}

.information-space .task-text > div {
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/styles/TaskWindow.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,SAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;;EAET,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;;EAE3B,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EAEnB,mDAAmD;EACnD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".main-panel {\n  display: flex;\n  overflow: hidden;\n  max-width: 100%;\n  flex: 1 1 0;\n}\n\n.information-space {\n  flex: 0 0 300px;\n  gap: 20px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n\n  overflow: auto;\n}\n\n.information-space > * {\n  width: 205px;\n}\n\n.information-space .task-text {\n  border: solid 1px #1a6a7c;\n  border-radius: 10px;\n  background: #ffffff;\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  overflow: hidden;\n  min-height: 120px;\n}\n\n.information-space .task-text > div {\n  padding: 10px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
